// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-modal-info {
  height: 100vh;
  position: relative;
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
  background-color: var(--background-color);
}

.slide-col {
  top: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  width: min-content;
  flex-direction: column;
  background-size: 100% 30vh !important;
  overflow: auto;
}

.option-group-col {
  flex-grow: 1;
  overflow: auto;
  flex-shrink: 1;
  flex-basis: auto;
  padding: 15px 20px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-img {
  position: absolute;
  top: 30px;
  left: 30px;
}

.image-wrapper {
  background: black url('modal-info.png') no-repeat center center/100% 100%;
  position: relative;
}
.image-wrapper .back_icon {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 99;
  zoom: 1.5;
}
.image-wrapper .cross_icon {
  z-index: 99;
  position: absolute;
  right: 10px;
  top: 10px;
  zoom: 1.5;
}

.main-img {
  height: 35vh;
  width: 100%;
  margin: 0 auto 0px;
}
.main-img.full-width {
  object-fit: cover;
}

.default-img {
  height: 35vh;
  width: 100px !important;
}

.info {
  padding: 20px;
}
.info .title {
  text-align: center;
  text-transform: uppercase;
  font-size: 25px;
  line-height: var(--modal-info-title-line-height);
  margin-bottom: 6px;
  padding-top: 10px;
  color: var(--ion-color-primary);
}
.info .desc {
  text-align: center;
  font-size: var(--modal-info-desc-font-size);
  font-family: AppFontNormal, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: #1A1A18;
}

.menge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 20px 20px;
}
.menge h5 {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  text-transform: uppercase;
}

ion-button {
  position: relative;
}
ion-button .buuton-text {
  font-size: var(--modal-info-button-font-size);
  color: var(--modal-info-button-text-color);
  margin-right: 50px;
}
ion-button .buuton-text.one-button {
  margin-right: 0;
}
ion-button .button-price {
  font-size: var(--modal-info-button-font-size);
  color: var(--modal-info-button-text-color);
}
ion-button .button-price.one-button {
  margin-right: 44px;
}
ion-button .button-icon {
  position: absolute;
  right: 5px;
  height: 34px;
  width: 34px;
}

ion-toolbar {
  height: 60px;
  display: flex;
  align-items: center;
  --background: var(--background-color);
}
ion-toolbar ion-title {
  font-weight: 100;
  padding-inline: unset !important;
  font-size: 16px;
  text-align: left;
  margin-left: 40px;
  font-family: AppFontBold, sans-serif;
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  padding: 8px;
  font-size: 15px;
}

.option-group-description {
  line-height: 95%;
  padding: 20px 25px;
  color: var(--ion-color-black);
  font-size: 20px;
  text-align: left;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  background: white;
}

swiper-container {
  height: 100% !important;
}

ion-page {
  background: transparent;
}

.slider-select-half {
  height: 100%;
  width: 100%;
}

.separator {
  height: 14px;
  width: 100%;
  background: url('separator_doted.svg') no-repeat center center/100% 100%;
}
@media (min-width: 991px) {
  .separator {
    background: url('separator_doted.svg') no-repeat center center/100% 130%;
  }
}
@media (min-width: 991px) and (max-height: 750px) {
  .separator {
    height: 11px;
  }
}

.allergens {
  margin: 5px 20px;
}
.allergens app-accordion-list {
  width: 100%;
}

.padding-block {
  padding: 0px 20px;
}

.vertical-line {
  content: " ";
  width: 1px;
  height: 20px;
  color: white;
  background: white;
  margin-inline: 10px;
}

.add-background {
  background: black url('background.png') no-repeat center center/100% 100% !important;
  background-size: cover;
}

.button-footer-block {
  flex-wrap: wrap;
  background: white;
  justify-content: center;
  margin: 0px !important;
  padding: 0 15px 15px 15px;
  width: max-content;
  min-width: 450px;
  z-index: 999;
  box-shadow: 0px -4px 50px 0px rgba(0, 0, 0, 0.1019607843);
  display: flex;
  font-size: 16px;
}
.button-footer-block ion-button {
  --padding-start: 24px;
  --padding-end: 7px;
  width: max-content;
  max-width: max-content;
  margin-left: 10px;
  margin-top: 15px;
  flex-grow: 1;
}
.button-footer-block ion-button.one-button {
  width: 100%;
}
.button-footer-block .buy_without_options {
  width: max-content;
  flex-grow: 12;
  --padding-start: 20px;
  --padding-end: 20px;
}

.style-block {
  height: 100%;
  overflow-y: auto;
  width: 100%;
}

.show-option-groups {
  background: white;
  display: flex;
  align-items: center;
}

.delete-option {
  position: absolute;
  bottom: 15px;
  right: 15px;
  z-index: 99;
  background: var(--ion-color-primary);
  border-top-left-radius: 15px;
  text-align: center;
  padding: 7px;
  border: 2px dotted white;
  width: 80px;
  height: 80px;
  min-height: 80px;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.delete-option p {
  font-size: 13px;
  font-family: "AppFontBold";
  text-transform: uppercase;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kBAAA;AADF;;AAIA;EACE,sBAAA;EACA,uBAAA;EACA,yCAAA;AADF;;AAIA;EACE,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;AADF;;AAMA;EACE,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,YAAA;EACA,cAAA;AAHF;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAHF;;AAKA;EACE,yEAAA;EACA,kBAAA;AAFF;AAGE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;AADJ;AAGE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AADJ;;AAIA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AADF;AAEE;EACE,iBAAA;AAAJ;;AAGA;EACE,YAAA;EACA,uBAAA;AAAF;;AAEA;EAEE,aAAA;AAAF;AACE;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gDAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;AACJ;AAEE;EACE,kBAAA;EACA,2CAAA;EACA,sCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,cAAA;AADJ;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EAMA,qBAAA;AARF;AAGE;EACE,oCAAA;EACA,eAAA;EACA,yBAAA;AADJ;;AAOA;EACE,kBAAA;AAJF;AAME;EACE,6CAAA;EACA,0CAAA;EACA,kBAAA;AAJJ;AAMI;EACE,eAAA;AAJN;AAQE;EACE,6CAAA;EACA,0CAAA;AANJ;AAOI;EACE,kBAAA;AALN;AASE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAPJ;;AAWA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;AARF;AASE;EACE,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;AAPJ;AASE;EACE,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,+BAAA;AAPJ;AAUE;EACE,YAAA;EACA,eAAA;AARJ;;AAWA;EACE,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,iBAAA;AARF;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,uBAAA;AAPF;;AASA;EACE,YAAA;EACA,WAAA;AANF;;AAQA;EACC,YAAA;EACA,WAAA;EACA,wEAAA;AALD;ACxLE;ED0LF;IAKI,wEAAA;EAHF;AACF;AAGE;EANF;IAOG,YAAA;EAAD;AACF;;AAGA;EACE,gBAAA;AAAF;AACE;EACE,WAAA;AACJ;;AAEA;EACE,iBAAA;AACF;;AACA;EACE,YAAA;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAEJ;;AAAA;EACE,oFAAA;EACA,sBAAA;AAGF;;AADA;EACE,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,yDAAA;EACA,aAAA;EACA,eAAA;AAIF;AAHE;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAKJ;AAHI;EACE,WAAA;AAKN;AAFE;EACE,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AAIJ;;AADA;EACE,YAAA;EACA,gBAAA;EACA,WAAA;AAIF;;AAFA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;AAKF;;AAHA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,oCAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;EACE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAKJ;AAJE;EACE,eAAA;EAEA,0BAAA;EACA,yBAAA;EACA,YAAA;AAKJ","sourcesContent":["@import \"../../../theme/mixins\";\n\napp-modal-info {\n  height: 100vh;\n  position: relative;\n}\n\nion-slides {\n  width: 100% !important;\n  height: 100% !important;\n  background-color: var(--background-color);\n}\n\n.slide-col {\n  top: 0;\n  bottom: 0;\n  position: absolute;\n  display: flex;\n  width: min-content;\n  flex-direction: column;\n  background-size: 100% 30vh !important;\n  overflow: auto;\n\n  // padding: 23px;\n}\n\n.option-group-col {\n  flex-grow: 1;\n  overflow: auto;\n  flex-shrink: 1;\n  flex-basis: auto;\n  padding: 15px 20px;\n}\n\n.grow {\n  flex-grow: 1;\n  overflow: auto;\n}\n\n.back-img {\n  position: absolute;\n  top: 30px;\n  left: 30px;\n}\n.image-wrapper {\n  background: black url('../../../assets/losteria/modal-info.png') no-repeat center center / 100% 100%;\n  position: relative;\n  .back_icon {\n    position: absolute;\n    left: 10px;\n    top: 10px;\n    z-index: 99;\n    zoom: 1.5;\n  }\n  .cross_icon {\n    z-index: 99;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    zoom: 1.5;\n  }\n}\n.main-img {\n  height: 35vh;\n  width: 100%;\n  margin: 0 auto 0px;\n  &.full-width {\n    object-fit: cover;\n  }\n}\n.default-img {\n  height: 35vh;\n  width: 100px !important;\n}\n.info {\n\n  padding: 20px;\n  .title {\n    text-align: center;\n    text-transform: uppercase;\n    font-size: 25px;\n    line-height: var(--modal-info-title-line-height);\n    margin-bottom: 6px;\n    padding-top: 10px;\n    color: var(--ion-color-primary)    ;\n  }\n\n  .desc {\n    text-align: center;\n    font-size: var(--modal-info-desc-font-size);\n    font-family: AppFontNormal, sans-serif;\n\n    line-height: var(--modal-info-desc-line-height);\n    padding-bottom: 10px;\n    color: #1A1A18\n    ;\n  }\n}\n\n.menge {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  h5 {\n    font-family: AppFontBold,sans-serif;\n    font-size: 18px;\n    text-transform: uppercase;\n  }\n  margin: 0px 20px 20px;\n}\n\n\nion-button {\n  position: relative;\n  \n  .buuton-text {\n    font-size: var(--modal-info-button-font-size);\n    color: var(--modal-info-button-text-color);\n    margin-right: 50px;\n\n    &.one-button {\n      margin-right: 0;\n    }\n  }\n\n  .button-price {\n    font-size: var(--modal-info-button-font-size);\n    color: var(--modal-info-button-text-color);\n    &.one-button {\n      margin-right: 44px;\n    }\n  }\n\n  .button-icon {\n    position: absolute;\n    right: 5px;\n    height: 34px;\n    width: 34px;\n  }\n}\n\nion-toolbar {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  --background: var(--background-color);\n  ion-title {\n    font-weight: 100;\n    padding-inline: unset !important;\n    font-size: 16px;\n    text-align: left;\n    margin-left: 40px;\n    font-family: AppFontBold ,sans-serif;\n  }\n  ion-button {\n    --background: transparent;\n    --background-activated: transparent;\n    --background-focused: transparent;\n    --background-hover: transparent;\n  }\n\n  ion-icon {\n    padding: 8px;\n    font-size: 15px;\n  }\n}\n.option-group-description {\n  line-height: 95%;\n  padding: 20px 25px;\n  color: var(--ion-color-black);\n  font-size: 20px;\n  text-align: left;  \n  font-family: AppFontBold, sans-serif;\n  text-transform: uppercase;\n  background: white;\n}\nswiper-container {\n  height: 100% !important;\n}\n\nion-page {\n  background: transparent;\n}\n.slider-select-half {\n  height: 100%;\n  width: 100%;\n}\n.separator {\n\theight: 14px;\n\twidth: 100%;\n\tbackground: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 100%;\n\t@include desktop {\n    background: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 130%;\n\t\t@media (max-height: 750px) {\n\t\t\theight: 11px;\n\t\t}\n\t}\n}\n.allergens {\n  margin: 5px 20px;\n  app-accordion-list {\n    width: 100%;\n  }\n}\n.padding-block {\n  padding: 0px 20px;\n}\n.vertical-line {\n  content: ' ';\n    width: 1px;\n    height: 20px;\n    color: white;\n    background: white;\n    margin-inline: 10px;\n}\n.add-background {\n  background: black url(../../../assets/background/background.png)  no-repeat center center / 100% 100% !important;\n  background-size: cover;\n}\n.button-footer-block {\n  flex-wrap: wrap;\n  background: white;\n  justify-content: center;\n  margin: 0px !important;\n  padding: 0 15px 15px 15px;\n  width: max-content;\n  min-width: 450px;\n  z-index: 999;\n  box-shadow: 0px -4px 50px 0px #0000001A;\n  display: flex;\n  font-size: 16px;\n  ion-button {\n    --padding-start: 24px;\n    --padding-end: 7px;\n    width: max-content;\n    max-width: max-content;\n    margin-left: 10px;\n    margin-top: 15px;\n    flex-grow: 1;\n\n    &.one-button {\n      width: 100%;\n    }\n  }\n  .buy_without_options {\n    width: max-content;\n    flex-grow: 12;\n    --padding-start: 20px;\n    --padding-end: 20px;\n  }\n}\n.style-block {\n  height: 100%;\n  overflow-y: auto;\n  width: 100%;\n}\n.show-option-groups {\n  background: white;\n  display: flex;\n  align-items: center;\n}\n.delete-option {\n  position: absolute;\n  bottom: 15px;\n  right: 15px;\n\n  z-index: 99;\n  background:  var(--ion-color-primary);;\n  border-top-left-radius: 15px;\n  text-align: center;\n  padding: 7px;\n    border: 2px dotted white;\n    width: 80px;\n    height: 80px;\n    min-height: 80px;\n    min-width: 80px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n  p {\n    font-size: 13px;\n\n    font-family: 'AppFontBold';\n    text-transform: uppercase;\n    color:white;\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
